import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import employeeReducer from './slices/employeeSlice';
import leaveReducer from './slices/leaveSlice';
import leaveTypeReducer from './slices/leaveTypeSlice';
import attendanceReducer from './slices/attendanceSlice';
import payrollReducer from './slices/payrollSlice';
import ctcReducer from './slices/ctcSlice';
import documentsReducer from './slices/documentsSlice';
import taxDeclarationReducer from './slices/taxDeclarationSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    employees: employeeReducer,
    leaves: leaveReducer,
    leaveTypes: leaveTypeReducer,
    attendance: attendanceReducer,
    payroll: payrollReducer,
    ctc: ctcReducer,
    documents: documentsReducer,
    taxDeclaration: taxDeclarationReducer
  }
});

export default store;
